module.exports = __webpack_public_path__ + "img/chinesecompany08.bf03ba4e.png";